import { formatNum, parseNum } from "../../utils/numbers";

const calculateTax = (taxRate, base) => {
    let total = undefined;
    if (!isNaN(taxRate) && !isNaN(base)) {
        total = (base * taxRate) / 100;
    }
    return {
        base,
        total,
    };
};

export default calculateTax;

export const calculateTaxItem = (userInfo, base, taxRate) => {
    base = parseNum(base, userInfo.decimalDelimiter, userInfo.thousandDelimiter);
    taxRate = parseNum(taxRate, userInfo.decimalDelimiter, userInfo.thousandDelimiter);

    if (isNaN(base) || isNaN(taxRate)) {
        return {};
    }

    const calculated = calculateTax(taxRate, base);
    const result = {
        base: formatNum(calculated.base, 2, userInfo.decimalDelimiter, userInfo.thousandDelimiter),
        total: formatNum(
            calculated.total,
            2,
            userInfo.decimalDelimiter,
            userInfo.thousandDelimiter
        ),
    };

    return result;
};
